export const SIZE_DEFAULT = 'default';
export const SIZE_SMALL = 'small';
export const SIZE_MEDIUM = 'medium';
export const SIZE_BIG = 'big';
